import axiosInstance from '../config/axios';
import permissionsService, { getUserRolePermissions } from './permissionsService';
import { syncUserPermissions } from './permissionsSyncService';
import { broadcastAuthData } from './tabSyncService';

// تسجيل دخول المستخدم
export const userLogin = async (identifier, password) => {
  try {
    const response = await axiosInstance.post(`/api/login`, {
      identifier,
      password
    });
    if (response.data.token) {
      // حفظ معلومات المستخدم والتوكن
      sessionStorage.setItem('token', response.data.token);
      sessionStorage.setItem('userType', 'user');
      sessionStorage.setItem('user', JSON.stringify(response.data.user));
      
      // سنستخدم نهج الاستعلام المباشر من API لكل تبويب بدلا من الكوكيز
      
      // تخزين معرف الدور بدلاً من اسم الدور
      const userRoleId = response.data.user.role_id || '';
      sessionStorage.setItem('userRoleId', userRoleId);
      
      // مزامنة الصلاحيات من API
      try {
        await syncUserPermissions();
        // syncUserPermissions ستقوم بحفظ userPermissions فى sessionStorage والكوكيز
        // User permissions updated from API
      } catch (permError) {
        // Failed to update permissions from API
      }
      
      // إنشاء وتخزين حدث تغيير التخزين المحلي لتحديث الصلاحيات فى نفس التبويب فقط
      window.dispatchEvent(new Event('permissionsChanged'));
            // تسجيل الدخول في نظام تاريخ الدخول/الخروج
            try {
              // Sending login request to login history system
              // تم إزالة طلب تسجيل الدخول في نظام تاريخ الدخول/الخروج لأنه تم نقله إلى الباك إند
              // Login successful in login history system
            } catch (historyError) {
              // نتجاهل الخطأ هنا لأن نظام تاريخ الدخول/الخروج غير حرج
              // Error logging in login history system
            }
    }
    return response.data;
  } catch (error) {
    // User login error
    throw error.response?.data || error.message;
  }
};

// تسجيل دخول المدير
export const adminLogin = async (identifier, password) => {
  try {
    const response = await axiosInstance.post(`/api/admin/login`, {
      identifier,
      password
    });
    if (response.data.token) {
      // حفظ معلومات المدير والتوكن في sessionStorage
      sessionStorage.setItem('token', response.data.token);
      sessionStorage.setItem('userType', 'admin');
      sessionStorage.setItem('user', JSON.stringify(response.data.user));
      
      // تخزين معرف دور المدير من الاستجابة
      const userRoleId = response.data.user.role_id || '1'; // استخدام معرف افتراضي للمدير إذا لم يكن متوفرًا
      sessionStorage.setItem('userRoleId', userRoleId);
      
      // لا نستخدم الكوكيز، سنعتمد على API لجلب البيانات في كل تبويب
      
      // مزامنة الصلاحيات من API
      try {
        await syncUserPermissions();
        // Admin permissions updated from API
        
        // بث معلومات المصادقة للتبويبات الأخرى
        broadcastAuthData({
          token: response.data.token,
          userType: 'admin',
          userRoleId,
          user: response.data.user
        });
      } catch (permError) {
        // Failed to update permissions from API
        
        // إذا فشلت المزامنة، نستخدم صلاحيات افتراضية كملجأ أخير
        const allPermissions = [
          // الدورات
          'view_courses', 'create_course', 'edit_course', 'delete_course',
          'view_course_content', 'create_course_content', 'edit_course_content', 'delete_course_content',
          'view_exams', 'create_exam', 'edit_exam', 'delete_exam',
          
          // المستخدمين
          'view_admins', 'create_admin', 'edit_admin', 'delete_admin',
          'view_instructors', 'create_instructor', 'edit_instructor', 'delete_instructor',
          'view_trainees', 'create_trainee', 'edit_trainee', 'delete_trainee',
          
          // الأجهزة
          'view_devices', 'manage_devices', 'delete_devices',
          
          // المدفوعات
          'view_bank_transfers', 'verify_bank_transfers', 'delete_bank_transfers',
          'view_electronic_payments', 'manage_electronic_payments', 'delete_electronic_payments',
          
          // الخصومات
          'view_coupons', 'create_coupon', 'edit_coupon', 'delete_coupon',
          'view_course_discounts', 'create_course_discount', 'edit_course_discount', 'delete_course_discount',
          
          // الكتب
          'view_books', 'create_book', 'edit_book', 'delete_book',
          
          // التقييمات
          'view_reviews', 'create_review', 'edit_review', 'delete_review',
          
          // الكلمات المفتاحية
          'view_keywords', 'create_keyword', 'edit_keyword', 'delete_keyword',
          
          // الإعدادات
          'view_settings', 'manage_settings'
        ];
        
        // حفظ الصلاحيات ليستخدمها نظام الصلاحيات الجديد
        // تأكد من استخدام userPermissions للتوافق مع مكونات التحقق من الصلاحيات
        sessionStorage.setItem('userPermissions', JSON.stringify(allPermissions));
        // تخزين في sessionStorage فقط
        
        // إضافة صلاحية الوصول للوحة التحكم إلى قائمة الصلاحيات
        const permissionsWithAccess = [...allPermissions, 'access_dashboard'];
        sessionStorage.setItem('userPermissions', JSON.stringify(permissionsWithAccess));
        // تخزين في sessionStorage فقط
      }
      
      // إنشاء وتخزين حدث تغيير التخزين المحلي لتحديث الصلاحيات فى نفس التبويب فقط
      window.dispatchEvent(new Event('permissionsChanged'));
            // تسجيل الدخول في نظام تاريخ الدخول/الخروج
            try {
              // Sending login request to login history system
              // تم إزالة طلب تسجيل الدخول في نظام تاريخ الدخول/الخروج لأنه تم نقله إلى الباك إند
              // Login successful in login history system
            } catch (historyError) {
              // نتجاهل الخطأ هنا لأن نظام تاريخ الدخول/الخروج غير حرج
              // Error logging in login history system
            }
    }
    return response.data;
  } catch (error) {
    // Admin login error
    throw error.response?.data || error.message;
  }
};

// إعادة تعيين كلمة المرور للمتدرب
export const traineeResetPassword = async (email) => {
  try {
    const response = await axiosInstance.post(`/api/trainee/reset-password`, { email });
    return response.data;
  } catch (error) {
    // Trainee reset password error
    throw error.response?.data || error.message;
  }
};

// إعادة تعيين كلمة المرور للمدير
export const adminResetPassword = async (email) => {
  try {
    const response = await axiosInstance.post(`/api/admin/reset-password`, { email });
    return response.data;
  } catch (error) {
    // Admin reset password error
    throw error.response?.data || error.message;
  }
};

// تسجيل الخروج
export const logout = async () => {
  try {
    // التأكد من وجود توكن
    const token = sessionStorage.getItem('token');
    if (token) {
      // إرسال طلب تسجيل الخروج إلى الخادم (نظام الأجهزة)
      // Sending logout request to server
      await axiosInstance.post('/api/logout');
      // Logout successful from server
      
      // إرسال إشارة تسجيل الخروج للتابات الأخرى بعد الانتهاء من طلب API
      try {
        broadcastAuthData({ action: 'LOGOUT', timestamp: Date.now() });
      } catch (err) {
        // تجاهل أي أخطاء في البث
      }
      
      // تم نقل تسجيل الخروج في نظام تاريخ الدخول/الخروج إلى الباك إند
    }
  } catch (error) {
    // Error logging out from server
  } finally {
    // مسح محتوى السلة من localStorage
    localStorage.removeItem('cartState');
    // Storage check before logout
    
    // حذف بيانات التسجيل من sessionStorage
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('user');
    sessionStorage.removeItem('userType');
    sessionStorage.removeItem('userRole');
    sessionStorage.removeItem('userRoleId');
    sessionStorage.removeItem('rolePermissions');
    sessionStorage.removeItem('customPermissions');
    sessionStorage.removeItem('permissions');
    sessionStorage.removeItem('userPermissions');
    
    // حذف بيانات الدورات المشترك فيها
    sessionStorage.removeItem('dose_user_courses');
    
    // حذف كل البيانات المتعلقة بالموقع
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i);
      if (key && key.startsWith('dose_')) {
        sessionStorage.removeItem(key);
      }
    }
    
    // لم نعد نستخدم الكوكيز، لا داعي لحذفها
    
    // Storage check after logout and data clearing
    
    // توجيه المستخدم للصفحة الرئيسية
    window.location.href = '/';
  }
};

// التحقق من حالة تسجيل الدخول
export const isAuthenticated = () => {
  return !!sessionStorage.getItem('token');
};

// الحصول على نوع المستخدم الحالي
export const getUserType = () => {
  return sessionStorage.getItem('userType');
};

export const authService = {
  userLogin,
  adminLogin,
  traineeResetPassword,
  adminResetPassword,
  logout,
  isAuthenticated,
  getUserType
};

export default authService;
